// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1J0Wm","buttons":"Footer_buttons__2qiod"};